var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{class:['sprite-icon', ("sprite-" + (_vm.props.name))]})}
var staticRenderFns = []

export { render, staticRenderFns }